

const moduleColors = {
    partiallyAttempted: "#F1D560",
    currentlySelected: "#007BFF",
    wrongAnswer: "#C71B16",
    noAction: "#757589",
    rightAnswer: "#57BD72",
}

const moduleBoxHWBr = {
    borderRadius: 4,
    width: 20,
    height: 20,
}

const moduleDesc = {
    color: "#757589",
    fontSize: 12
}

const questionsModule = {
    width: 35,
    height: 34,
    borderRadius: "50%",
    border: "1px solid #DFDFDF",
    fontSize: 14,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
}

const questions = {
    rightAnswer: { backgroundColor: moduleColors.rightAnswer, color: "#fff", ...questionsModule },
    partiallyAttempted: { backgroundColor: moduleColors.partiallyAttempted, color: "#fff", ...questionsModule },
    currentlySelected: { ...questionsModule, border: "3px solid black" },
    wrongAnswer: { backgroundColor: moduleColors.wrongAnswer, color: "#fff", ...questionsModule },
    noAction: { color: moduleColors.noAction, backgroundColor: "#fff", ...questionsModule }
}

const getQuestionIndicatorStyle = (activity, i, currentQuestionIndex) => {
    let styleToReturn = {};

    // Check if question is attempted based on question type
    const response = activity?.questionresponse_set;
    const questionType = activity?.question_type;
    let isAttempted = false;

    console.log(`[getQuestionIndicatorStyle] Question ${i + 1} (ID: ${activity?.id}):`, {
        questionType,
        hasResponse: !!response,
        response_text: response?.response_text,
        response_options_ids: response?.response_options_ids
    });

    if (response) {
        // For Multiple Choice (S, M) - check response_options_ids
        if ((questionType === "S" || questionType === "M") && response.response_options_ids?.length > 0) {
            isAttempted = true;
            console.log(`[getQuestionIndicatorStyle] Question ${i + 1}: Attempted (Multiple Choice)`);
        }
        // For Text-based questions (D - Descriptive, F - Fill in blanks, N - Numeric) - check response_text
        else if ((questionType === "D" || questionType === "F" || questionType === "N") && response.response_text && response.response_text.trim() !== "") {
            isAttempted = true;
            console.log(`[getQuestionIndicatorStyle] Question ${i + 1}: Attempted (Text-based)`);
        }
        // For File Upload (U) - check if response_text contains a file path
        else if (questionType === "U" && response.response_text && response.response_text.trim() !== "") {
            isAttempted = true;
            console.log(`[getQuestionIndicatorStyle] Question ${i + 1}: Attempted (File Upload)`);
        }
        // Fallback: check if any response exists
        else if (response.response_text || response.response_options_ids?.length > 0) {
            isAttempted = true;
            console.log(`[getQuestionIndicatorStyle] Question ${i + 1}: Attempted (Fallback)`);
        }
    }

    if (isAttempted) {
        styleToReturn = { backgroundColor: "lightgreen", ...questionsModule };
    } else {
        styleToReturn = { backgroundColor: "white", ...questionsModule };
        console.log(`[getQuestionIndicatorStyle] Question ${i + 1}: NOT Attempted`);
    }

    // Add logic for current question index
    if (currentQuestionIndex === i) {
        styleToReturn = { ...styleToReturn, ...questions.currentlySelected };
    }

    return styleToReturn;
};

export {
    moduleBoxHWBr,
    moduleColors,
    getQuestionIndicatorStyle,
    questions,
    moduleDesc,
    questionsModule
}